import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetLandingPageStarters_pageStarters as PageStarter,
    GetLandingPageStarters as GetLandingPageStartersQuery,
} from 'nutshell-graphql-types';

import GET_LANDING_PAGE_STARTERS from '../queries/get-landing-page-starters.graphql';

export function useGetLandingPageStarters(): {
    pageStarters: PageStarter[] | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const {data, error, loading} = useQuery<GetLandingPageStartersQuery, Record<any, any>>(
        GET_LANDING_PAGE_STARTERS,
        {
            fetchPolicy: 'cache-and-network',
        }
    );

    return {
        pageStarters: data ? data.pageStarters : undefined,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
